import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableContainer,
  Tooltip,
} from "@mui/material";

import { useTranslation } from "react-i18next";

import React, { useEffect, useState } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { FeatureTableRow } from "./FeatureTableRow";

export const FeatureLayer = ({ feature: f, tableRef, selectedFeatureTab }) => {
  const { t } = useTranslation("main");
  const feature = f[selectedFeatureTab];
  const [imageHeight, setImageHeight] = useState(200);
  const minImageHeight = 80;
  const maxImageHeight = 200;
  const [selectedImage, setSelectedImage] = useState(0);
  const imgUrls = extractImageLinks(feature?.properties);
  useEffect(() => {
    const adjustImageSize = () => {
      if (tableRef.current) {
        const maxScroll =
          tableRef.current.scrollHeight - tableRef.current.clientHeight;
        const scrollTop = tableRef.current.scrollTop;
        const scrollFactor = scrollTop / maxScroll; // Normaliza el scroll entre 0 y 1

        // Reduce la imagen progresivamente hasta su mínimo
        const newImageHeight =
          maxImageHeight - (maxImageHeight - minImageHeight) * scrollFactor;
        setImageHeight(newImageHeight);
      }
    };

    const tableDiv = tableRef.current;
    if (tableDiv) {
      tableDiv.addEventListener("scroll", adjustImageSize);
    }

    return () => {
      if (tableDiv) {
        tableDiv.removeEventListener("scroll", adjustImageSize);
      }
    };
  }, []);

  const propertiesToOmit = [
    "uuid",
    "layer_uuid",
    "id",
    "value",
    "shape_length",
    "district_tx",
    "major_neighborhood",
    "district_bar_code",
    "neighborhood_number",
    "neighborhood_mt",
    "district_b_code",
    "image_url",
    "risk_simplify_type",
    "risk_form_value",
  ];

  function extractImageLinks(obj) {
    let imageLinks = [];

    function searchImages(value) {
      if (
        typeof value === "string" &&
        value.match(
          /^https?:\/\/.*\.(jpg|jpeg|png|gif|webp|bmp|svg|tiff)(\?.*)?$/i
        )
      ) {
        imageLinks.push(value);
      } else if (typeof value === "object" && value !== null) {
        Object.values(value).forEach(searchImages);
      }
    }

    searchImages(obj);
    return imageLinks;
  }

  const handlePrevImage = () => {
    setSelectedImage((prev) => (prev === 0 ? imgUrls.length - 1 : prev - 1));
  };

  const handleNextImage = () => {
    setSelectedImage((prev) => (prev === imgUrls.length - 1 ? 0 : prev + 1));
  };

  return (
    <>
      {imgUrls?.length > 0 && (
        <div
          className="no-scroll"
          style={{
            display: "flex",
            width: "calc(38rem - 10px)",
            width: "38rem",
            maxWidth: "calc(90vw - 10px)",
            justifyContent: "space-between",
            alignItems: "center",
            position: "fixed",
            backgroundColor: "white",
            paddingBottom: "1rem",
          }}
        >
          <div>
            {imgUrls?.length > 1 && (
              <IconButton onClick={handlePrevImage}>
                <ArrowBackIosNewIcon />
              </IconButton>
            )}
          </div>
          <Tooltip title={t("open_in_new_tab")} followCursor={true}>
            <a
              href={imgUrls?.[selectedImage]}
              target="_blank"
              rel="noopener noreferrer"
              style={{ pointerEvents: "auto" }}
            >
              <img
                key={imgUrls?.[selectedImage]}
                src={imgUrls?.[selectedImage]}
                alt="Feature"
                style={{
                  width: "auto",
                  maxWidth: "100%",
                  borderRadius: "5px",
                  height: `${imageHeight}px`,
                  objectFit: "cover",
                }}
              />
            </a>
          </Tooltip>
          <div>
            {imgUrls?.length > 1 && (
              <IconButton onClick={handleNextImage}>
                <ArrowForwardIosIcon />
              </IconButton>
            )}
          </div>
        </div>
      )}
      <TableContainer
        component={Paper}
        style={{
          boxShadow: "none",
          padding: "0",
          overflow: "visible",
          ...(imgUrls?.length > 0 && { marginTop: "calc(200px + 1rem)" }),
        }}
      >
        <Table aria-label="feature table">
          <TableBody>
            {Object.entries(feature?.properties)
              .filter(([key]) => !propertiesToOmit.includes(key))
              .map(([field, value]) => {
                if (typeof value === "object" || !value) return null;

                return (
                  <FeatureTableRow
                    selectedFeature={feature}
                    field={field}
                    value={value}
                  />
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
